/** C-1 — locale okuma/değiştirme hook'u (dil seçici + yön için). */
import { Direction, directionOf, Locale, SUPPORTED_LOCALES } from './locales';
import { useLocaleStore } from './store';

export interface UseLocaleResult {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  direction: Direction;
  supported: readonly Locale[];
}

export function useLocale(): UseLocaleResult {
  const locale = useLocaleStore((state) => state.locale);
  const setLocale = useLocaleStore((state) => state.setLocale);
  return { locale, setLocale, direction: directionOf(locale), supported: SUPPORTED_LOCALES };
}
